<template>
  <div class="ma-3">
    <SimCardDetailsDialog ref="simDetailsDialog" />

    <OCol fill-x scroll-y class="pa-3 children-pa-3">
      <ORow class="gap-6">
        <OTextField class="w-1/3" label="Nome/Apelido" v-model="value.name" />
        <OTextField class="w-1/3" label="IMEI" v-model="value.imei" readonly />
        <OSelect
          class="w-1/3"
          label="Modelo"
          v-model="value.model"
          :items="allModels"
          clearable
        />

        <!-- <div class="w-1/3">
          <BasePicker
            style="min-width: 300px"
            label="SIM Card"
            :value="simCardStr"
            icon="mdi-sim-outline"
            @open="showSimDetails"
            :clearable="false"
          />
        </div> -->
      </ORow>

      <ORow class="gap-6">
        <div class="w-1/3">
          <DepotPicker
            v-model="value.depot"
            orientation="vertical"
            single
            whenEmpty="(nenhum)"
          />
        </div>

        <OTextField
          class="w-1/3"
          label="Lote"
          v-model="value.batchNumber"
          append-icon="mdi-package-variant-closed"
          clearable
        />

        <OTextField
          class="w-1/3"
          label="MAC Address"
          v-model="value.macAddress"
          append-icon="mdi-memory"
          clearable
        />
      </ORow>

      <OTextarea label="Descrição" v-model="value.description" filled />

      <ORow>
        <OCapCont class="oderon-col-4" label="Criado em">
          {{ value.createdAt | moment('DD/MM/YYYY HH:mm') }}
        </OCapCont>
        <OCapCont class="oderon-col-4" label="Atualizado em">
          {{ value.updatedAt | moment('DD/MM/YYYY HH:mm') }}
        </OCapCont>
        <OCapCont class="oderon-col-4" label="Desativado em">
          {{ value.deletedAt | moment('DD/MM/YYYY HH:mm') }}
        </OCapCont>
      </ORow>

      <ORow right style="width: auto" class="mt-12">
        <v-btn text class="mr-2" :disabled="!isDirty" @click="$emit('reload')">
          Cancelar
        </v-btn>
        <v-btn color="primary" :disabled="!isDirty" @click="save">Salvar</v-btn>
      </ORow>
    </OCol>
  </div>
</template>

<script>
import EditStore from './EditStore'
import SimCardDetailsDialog from '../sim-cards/DetailsDialog.vue'
import DepotPicker from '../../../components/pickers/DepotPicker.vue'

export default {
  tabTitle: 'Geral',
  components: {
    DepotPicker,
    SimCardDetailsDialog
  },
  data() {
    return {
      allModels: [
        { text: 'JC 400', value: 'jc400' },
        { text: 'JC 400 AD', value: 'jc400ad' },
        { text: 'JC 371', value: 'jc371' }
      ]
    }
  },
  computed: {
    value() {
      return EditStore.row
    },
    isDirty() {
      return EditStore.isDirty
    }
  },
  methods: {
    save() {
      this.$loading(async () => {
        const { name, description, macAddress, batchNumber, model } = this.value
        const depotId = this.value.depot && this.value.depot.id
        const simCardId = this.value.simCard && this.value.simCard.id
        await EditStore.patch({
          name,
          description,
          simCardId,
          depotId,
          batchNumber,
          macAddress,
          model
        })
        this.$snack('Salvo com sucesso')
      })
    }
  }
}
</script>

<style></style>
